import React, { useState } from "react";
import Business from "./Business";
import styles from "./Entry.module.css";
import Website from "./Website";

function Entry() {
  const [index, setIndex] = useState(1);
  return (
    <>
      <div className={styles.AdminEntry}>
        <div className={styles.pages}>
          <div className={styles.toggle}>
            <div
              className={index === 1 ? styles.businessactive : styles.business}
              onClick={() => setIndex(1)}
            >
              <h4>Business</h4>
            </div>
            <div
              className={index === 0 ? styles.businessactive : styles.websiteunactive}
              onClick={() => setIndex(0)}
            >
              <h4>Website</h4>
            </div>
          </div>
        </div>
        {index === 0 ? <Website /> : <Business />}
      </div>
    </>
  );
}

export default Entry;
